module.exports = __webpack_public_path__ + "static/use-case-2-content-3-3ca529f9db343272949cbae032691263.png";